module.exports = ".cursor-pointer {\n  cursor: pointer; }\n\n.email-underline {\n  text-decoration: underline !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/update-profile/update-phone-number/update-phone-number.component.scss
// module id = ./src/app/shared/update-profile/update-phone-number/update-phone-number.component.scss
// module chunks = main